import * as yup from "yup";
import type { Asserts } from "yup";

// Response from /dimensions validation

const packageSizeSchema = yup.object().shape({
  id: yup.number().required(),
  title: yup.string().required(),
  image: yup.string().nullable(),
  hoverImage: yup.string().nullable(),
  weight: yup.string().nullable(),
  description: yup.string().nullable(),
});

const packageSizesSchema = yup.array().of(packageSizeSchema);

export type TPackageSizesResponse = Asserts<typeof packageSizesSchema>;

const validatePackageSizesResponse = (response: any): TPackageSizesResponse =>
  packageSizesSchema.validateSync(response);

export default validatePackageSizesResponse;
